<template lang="pug">
  .make-an-entry-weight
    .make-an-entry-content
      MakeAnEntryVisibility(text="Always Private")
      section.section.pb-1.pt-2.mt-2
        WtTitle(h4 bold) Enter weight
        BField
          .is-flex
            WtSvgIcon.m-1(icon="icon_weight" width="32px" height="32px")
            BField
              BInput.enter-weight-input(
                type="number"
                name="weight"
                :min="30"
                :max="700"
                v-model="weight"
              )
            span.m-1 {{memberWeightUnitText}}
        MakeAnEntryTip(:tip-category="'weight'")
    .level.is-mobile.program-settings-form-controls
      .level-left
      .level-right
        .level-item
          WtButton(
            is-text
            color="white"
            style="text-decoration:none"
            size="medium"
            @click.native="reset"
            :disabled="disableReset"
          ) Reset
        .level-item
          WtButton(@click.native="saveEntry" :loading="savingWeight" :disabled="disableSave") SAVE
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import { unitSettingsMixin } from "@/mixins/unitSettingsMixin";
import MakeAnEntryFooter from "@@/Members/MakeAnEntry/MakeAnEntryFooter";
import MakeAnEntryVisibility from "@@/Members/MakeAnEntry/MakeAnEntryVisibility";
import WtButton from "@@/WtButton/WtButton";
import WtTitle from "@@/WtTitle/WtTitle";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";
import MakeAnEntryTip from "@@/Members/MakeAnEntry/MakeAnEntryTip";

export default {
  name: "MakeAnEntryWeight",

  components: {
    WtTitle,
    WtButton,
    MakeAnEntryFooter,
    WtSvgIcon,
    MakeAnEntryTip,
    MakeAnEntryVisibility
  },

  mixins: [dateUtilityMixin, unitSettingsMixin],

  props: {
    uniqueKey: {
      type: String,
      default: null
    },

    fetchAction: {
      type: Function,
      default: () => {},
      required: true
    },

    entryItem: {
      type: Object,
      default: () => {},
      required: true
    },

    entryDate: {
      type: String,
      default: ""
    },

    formData: {
      type: FormData,
      required: true,
      validator: value => {
        return value instanceof FormData;
      }
    },

    saveEntryWrapper: {
      type: Function,
      required: true
    },

    disableSave: {
      type: Boolean,
      default: true
    },

    disableReset: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      weight: "",
      savingWeight: false
    };
  },

  computed: {
    ...mapGetters("members", ["member", "memberLoaded"]),

    memberWeightUnitText() {
      const memberDistanceUnits = this.memberLoaded
        ? this.memberUnits(this.member)
        : this.memberUnits(this.$auth.user());
      return memberDistanceUnits === "Kilometers" ? "kg" : "lb";
    },

    currentMetricValue() {
      let metric = this._.find(this.entryItem.wellnessMetrics, {
        type: "weight"
      });
      return this._.get(metric, "value", "");
    },

    setFormData() {
      if (!this._.isEmpty(this.entryItem)) {
        // either it's changed or it might have been changed and changed back to what it was
        return (
          this.weight !== this.currentMetricValue || this.formData.has("weight")
        );
      }
      return true;
    }
  },

  watch: {
    weight() {
      if (this.setFormData) {
        this.formData.set("weight", this.weight);
        this.$emit("formDataUpdated", true);
      }
    }
  },

  mounted() {
    this.weight = this.currentMetricValue;
  },

  methods: {
    ...mapActions("members", ["storeJournal", "updateJournal"]),

    saveEntry() {
      this.savingWeight = true;
      this.saveEntryWrapper(this.storeJournal, this.updateJournal);
    },

    reset() {
      const item = "weight";
      if (this.formData.has(item)) {
        this.formData.delete(item);
      }
      this.weight = this.currentMetricValue;
      this.$nextTick(() => {
        this.$emit("formReset", true);
      });
    }
  }
};
</script>

<style lang="sass">
.make-an-entry-weight
  .wellness-visibility
    position: absolute
    right: 1rem
    top: .5rem
  .enter-weight-input
    width: 6rem
  p.help.is-danger
    width: 6rem
.program-settings-form-controls
  margin-top: 20px
</style>
